import React from 'react';

import { useTranslation } from 'react-i18next';

import { RuleVariable } from '../types';

import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

import { ControlledTimestampRule } from './ControlledTimestampRule';

interface Props {
  rule: RuleVariable;
}

export const Rule: React.FC<Props> = ({ rule: { type, ruleVariableName } }) => {
  const { t } = useTranslation();

  switch (type) {
    case 'integer':
      return (
        <ControlledNumericField
          label={t(`dtrRules.variables.${ruleVariableName}`)}
          name={`rules.${ruleVariableName}.value`}
          step={10}
          fullWidth
        />
      );
    case 'double':
      return (
        <ControlledNumericField
          label={t(`dtrRules.variables.${ruleVariableName}`)}
          name={`rules.${ruleVariableName}.value`}
          step={0.1}
          fullWidth
        />
      );
    case 'timestamp':
      return <ControlledTimestampRule ruleVariableName={ruleVariableName} />;
    default:
      return <></>;
  }
};
